import types from "@/store/modules/headers/types";
import { createObject } from "./state";

/** @return { Object<string, import('vuex').Mutation> } */
export default {
	[types.SET_VALUES_EGGS_FOUND]: (state, { eggsFound }) => {
		state.eggsFound = eggsFound;
	},
};
